import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "col-12 col-lg-8"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "uq-preloader" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "loader loader--3" })
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "home py-56"
}
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "event-card" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FullCalendar = _resolveComponent("FullCalendar")!
  const _component_the_admin_calendar_event_create = _resolveComponent("the-admin-calendar-event-create")!
  const _component_the_admin_calendar_event_update = _resolveComponent("the-admin-calendar-event-update")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_FullCalendar, {
              ref: "calendar",
              class: "app-calendar",
              options: _ctx.calendarOptions
            }, {
              eventContent: _withCtx((arg) => [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", null, _toDisplayString(arg.event.title), 1)
                ])
              ]),
              _: 1
            }, 8, ["options"])
          ])
        ])),
    (_ctx.modalToShow === 'the-admin-calendar-event-create')
      ? (_openBlock(), _createBlock(_component_the_admin_calendar_event_create, {
          key: 2,
          "initial-date": _ctx.startCalendarEventDate,
          "start-date": _ctx.startCalendarEventDay,
          onClosed: _cache[0] || (_cache[0] = ($event: any) => {_ctx.modalToShow = null; _ctx.setStartCalendarEventDate()}),
          onCalendarEventCreated: _ctx.handleCalendarEventCreated
        }, null, 8, ["initial-date", "start-date", "onCalendarEventCreated"]))
      : _createCommentVNode("", true),
    (_ctx.modalToShow === 'the-admin-calendar-event-update')
      ? (_openBlock(), _createBlock(_component_the_admin_calendar_event_update, {
          key: 3,
          "calendar-event": _ctx.selectedCalendarEvent,
          onClosed: _cache[1] || (_cache[1] = ($event: any) => {_ctx.modalToShow = null; _ctx.setStartCalendarEventDate()}),
          onCalendarEventUpdated: _ctx.handleCalendarEventUpdated,
          onCalendarEventDeleted: _ctx.handleCalendarEventDeleted
        }, null, 8, ["calendar-event", "onCalendarEventUpdated", "onCalendarEventDeleted"]))
      : _createCommentVNode("", true)
  ], 64))
}